export const insertToArray = <T extends any>(
  arr: T[],
  index: number,
  ...newItems: T[]
): T[] => [...arr.slice(0, index), ...newItems, ...arr.slice(index)]

export const updateOneInArray = <T extends any>(
  array: T[],
  index: number,
  updateFnc: (object: T) => T
) => {
  const newObject = updateFnc(array[index])
  return [...array.slice(0, index), newObject, ...array.slice(index + 1)]
}
